// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQAmhohv76buC43AkAkKuoGUoJSjjsKk0",
  authDomain: "choose-your-fighter-8.firebaseapp.com",
  projectId: "choose-your-fighter-8",
  storageBucket: "choose-your-fighter-8.appspot.com",
  messagingSenderId: "223848489411",
  appId: "1:223848489411:web:08a9e917930188270d5d76"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);